import {login, logout, userGet} from '@/api/sys'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'

const state = {
  token: getToken(),
  name: 'sys',
  avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  introduction: '',
  user: {},
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  // user login
  login({commit}, admin) {
    const {username, password, code} = admin
    return new Promise((resolve, reject) => {
      login({username: username.trim(), password: password, code: code})
        .then(response => {
          const {data} = response
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          commit('SET_USER', data)
          resolve()
        }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({commit, state, dispatch}) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER', {})
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {root: true})

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUser({commit, state}) {
    return new Promise((resolve, reject) => {
      userGet()
        .then(res => {
          const {data} = res
          commit('SET_USER', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/user/store/modules/sys.js